/**
 * Local development entry point.
 *
 * In production, `MappingApp` is loaded as a remote module by the
 * xplatform shell, which owns the `MantineProvider` so this module
 * inherits its theme on first paint. This standalone entry provides
 * its own `XPlatformProvider` (the shared TecAlliance theme) so the
 * module can still be developed in isolation on port 5006.
 */
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { XPlatformProvider } from "@xplatform/design-system";
import "./styles/layers.css";
import "@mantine/core/styles.layer.css";
import "@mantine/notifications/styles.layer.css";
import "@mantine/dates/styles.layer.css";
import "@xplatform/design-system/styles.layer.css";
import "./config/i18n";
import "./index.scss";
import MappingApp from "./MappingApp";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(rootElement).render(
  <XPlatformProvider>
    <BrowserRouter>
      <MappingApp />
    </BrowserRouter>
  </XPlatformProvider>,
);
